import type {ReactNode} from "react";
import classes from "./StatusMessage.module.css";

export const StatusMessage = ({title, detail}: {title: string; detail: ReactNode}) => (
    <div className={classes.statusMessage}>
        <h2 className={classes.statusTitle}>{title}</h2>
        <p className={classes.statusDetail}>{detail}</p>
    </div>
);
